import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Homes from './Pages/Home/Homes';
import Member from './Pages/Members/Member';
import About from './Pages/About/About';
import Directors from './Pages/Directors/Directors';
import ContactUs from './Pages/Contact Us/ContactUs';
import RMBLeaders from './Pages/RMBLeaders/RMBLeaders';
import RMBIndia from './Pages/RMBIndia/RMBIndia';
import Meetings from './Pages/Meetings/Meetings';
import RMBJaipur from './Pages/RMBJaipur/RMBJaipur';
import BlogDetails from './Blogs copy/BlogDetails';
import BlogList from './Blogs copy/BlogList';
import { blogs } from './Blogs copy/BlogData';
import Leadership from './Pages/Directors/Leadership';
import Coordinator from './Pages/Directors/Coordinator';
import Members from './Pages/Members/TeamMember/Members';
import Login from './Member Login And Register/Login';
import Register from './Member Login And Register/Register';
import ProtectedRoute from './Dashbord/ProtectedRoute';
import Dashboard from './Dashbord/Dashbord';
import MemberPortal from './UserDashbord/MemberPortal';
import Gallery from './Pages/Gallery/Gallery';
import AllNews from './Pages/AllNews/AllNews';
import AllBirthdays from './Pages/Home/AllBirthdays';
import AllRMBianOfMeeting from './Pages/Home/AllRMBianOfMeeting';
import VisitorRegistor from './VisitorForm/VisitorRegistor';
import ExpressInterest from './VisitorForm/ExpressInterest';
import EventRegister from './VisitorForm/EventRegister';



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homes />} />
        <Route path="/home" element={<Homes />} />
        <Route path="/members" element={<Member />} />
        <Route path="/about" element={<About />} />
        <Route path="/directors" element={<Directors />} />
        <Route path="/leadership" element={<Leadership />} />
        {/* <Route path="/coordinator" element={<Coordinator />} /> */}
        <Route path="/contact" element={<ContactUs/>} />
        <Route path="/rmbleaders" element={<RMBLeaders/>} />
        {/* <Route path="/rmbindia" element={<RMBIndia/>} /> */}
        <Route path="/meetings" element={<Meetings/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/register" element={<Register/>} />
        <Route path="/rmbjaipur" element={<RMBJaipur/>} />
        <Route path="/memberportal" element={<MemberPortal/>} />
        <Route path="/gallery" element={<Gallery/>} />
        <Route path="/rotary-events" element={<AllNews/>} />
        <Route path="/birthdays" element={<AllBirthdays/>} />
        <Route path="/allrmbianofmeeting" element={<AllRMBianOfMeeting/>} />
        <Route path="/visitor-registration" element={<VisitorRegistor/>} />
        <Route path="/express-interest" element={<ExpressInterest/>} />
        <Route path="/event-register" element={<EventRegister/>} />

        <Route path="/blog/:title" element={<BlogDetails />} />
        <Route  path="/blogs" element={<BlogList blogs={blogs} count={100000000000}/>}/>
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}/>
         {/* <Route path="/dashboard" element={ <Dashboard />}/> */}
    
        </Routes>
    </Router>
  );
}

export default App;
